import React, { useContext } from 'react';
import Button from '@digital-hig/button';
import Grid from '@digital-hig/grid';
// import Typography from '@digital-hig/typography';
/* eslint-disable import/no-extraneous-dependencies */
import { Box } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CardDetails from '../../../common/cardDetails/cardDetails';
import { SRPContext } from '../../../common/context/srpContext';
import { PAGE_COUNT } from '../../../constants/app-constants';
import { getKebabCase, isMobileDevice } from '../../../utils/srp.util';
import ListingShimmer from './listingShimmer';
import { SRPStateInterface } from '../../../common/context/srpInterface';
import ListingRootElement from './style';
import EmptyState from '../../../common/cardDetails/emptyState';
import { searchResultLinkClick } from '../../../common/analyticsApi';
import { BASENAME } from '../../../common/constants';
import { getBaseURL } from '../../../common/utilities';

const Listing = () => {
  const { t } = useTranslation();
  const {
    srpStateRef = { current: SRPStateInterface },
    listPartners, loading, fetchPartnersData, setAppliedFilter,
  } = useContext(SRPContext);
  const { partners, pagination } = listPartners || SRPStateInterface.listPartners;
  const navigate = useNavigate();
  const location = useLocation(); // replaces history.location
  const param = useParams();

  const handleLoadMore = async () => {
    const { appliedFilter } = srpStateRef.current;
    const filter = {
      ...appliedFilter,
      pageNumber: appliedFilter?.pageNumber + 1,
    };
    setAppliedFilter(filter);
    await fetchPartnersData({
      search: filter,
      isSearch: true,
    });
  };
  const getURL = (item) => {
    const url = getBaseURL(param.locale, `${BASENAME}/${getKebabCase(item.name, item.display_name, true)}/${item.id}`);
    return url;
  };
  const handleViewMore = (item) => {
    sessionStorage.setItem('srpSearch', location.search);
    const { name } = item || {};
    searchResultLinkClick({ name, search: srpStateRef?.current?.appliedFilter?.search });
    const baseUrl = getURL(item);
    navigate(baseUrl);
  };

  // const getLink = (element) => getSuccessStoriesCardBaseURL(param.locale, element);
  return (
    <ListingRootElement>
      {
        <Grid className="grid-col">
          {!!partners?.length && partners?.map((item, index) => (
            <CardDetails
              // eslint-disable-next-line react/no-array-index-key
              key={`partners-${index}`}
              isTitleTranslate={false}
              handleViewMore={() => handleViewMore(item)}
              displayName={item.display_name}
              link={getURL(item)}
              headline={item.headline}
              logo={item?.logo_url}
              view
              dataWatLoc="partner cards"
              dataWatVal="view"
            />
          ))}
          {loading && [...Array(PAGE_COUNT).keys()].map((e) => (<ListingShimmer key={`shimmer-${e}`} img />))}
        </Grid>
      }
      {!loading && !partners?.length && <EmptyState />}
      <Box className="load-more">
        {!!partners?.length && (
          <Button
            size="defaultSize"
            variant="contained"
            onClick={handleLoadMore}
            disabled={
              !pagination?.next_page || loading
            }
            data-wat-val="Load more"
            data-wat-loc="partner cards"
          >
            {t('Load more')}
          </Button>
        )}
        {!isMobileDevice() && loading && <Skeleton height="55px" width="120px" />}
      </Box>
    </ListingRootElement>
  );
};
export default Listing;
